// extracted by mini-css-extract-plugin
module.exports = {"voyages":"EUcj70TDIk8fH2drS132v"};